import { identity, snakeCase, get } from 'lodash';
import { actions as pagerActions } from 'rp-react-pagination';
import { fetchData } from './gridDataTable';
import catalogueTableConf from '../config/upcomingSalesTable';
import { queryUrl } from '../helpers/urlBuilder';
import { getRefinementQueryParam } from '../helpers/refinementUtils';
import {
    catalogueStateKey,
    cataloguePagerLength,
    getCatalogueFilterOptionsKey,
    getCatalogueDataset,
    getCatalogueQueryParams,
} from '../helpers/catalogueUtils';
import { actions as tableActions } from '../modules/DataTable';

const { venueid, salesdate } = getCatalogueDataset();

export const CATALOGUE_REFINEMENT_CHANGE = 'CATALOGUE_REFINEMENT_CHANGE';
export const CATALOGUE_REFINEMENT_RESET = 'CATALOGUE_REFINEMENT_RESET';
export const CATALOGUE_DATA_CHANGE = 'CATALOGUE_DATA_CHANGE';

export const CATALOGUE_SHORTLIST_TOGGLE_REQUEST = 'CATALOGUE_SHORTLIST_TOGGLE_REQUEST';
export const CATALOGUE_SHORTLIST_TOGGLE_SUCCESS = 'CATALOGUE_SHORTLIST_TOGGLE_SUCCESS';
export const CATALOGUE_SHORTLIST_TOGGLE_FAILURE = 'CATALOGUE_SHORTLIST_TOGGLE_FAILURE';

export const CATALOGUE_SHORTLIST_FAILURE_LIGHTBOX_OPEN =
    'CATALOGUE_SHORTLIST_FAILURE_LIGHTBOX_OPEN';
export const CATALOGUE_SHORTLIST_FAILURE_LIGHTBOX_CLOSE =
    'CATALOGUE_SHORTLIST_FAILURE_LIGHTBOX_CLOSE';

function updateCatalogueData(payload) {
    return {
        type: CATALOGUE_DATA_CHANGE,
        payload,
    };
}

function changeCatalogueRefinement(payload) {
    return {
        type: CATALOGUE_REFINEMENT_CHANGE,
        payload,
    };
}

function resetCatalogueRefinement() {
    return {
        type: CATALOGUE_REFINEMENT_RESET,
    };
}

function fetchFilterOptions(filterKey) {
    return (dispatch, getState) => {
        const urlPrefix = '/bloodstock/sales/catalogues/';
        return fetch(
            queryUrl(
                `${urlPrefix}${venueid}/${salesdate}/refine/${snakeCase(filterKey)}`,
                {
                    refine: getRefinementQueryParam(
                        getState()[catalogueStateKey].refinement, filterKey
                    )
                }
            ),
            { credentials: 'include' }
        )
            .then(response => response.json());
    };
}

function shouldUpdateTable(state) {
    return !state[catalogueStateKey].dataTable.initialized;
}

/**
 * Update number of found lots by refinement
 *
 * @param {number} lotsFound
 * @returns {{}} Action
 */
export function updateCatalogueLotsFound(lotsFound) {
    return updateCatalogueData({ lotsFound });
}

export function updateCatalogueTable(page) {
    return (dispatch, getState) => {
        const url = get(
                getState(),
                `${catalogueStateKey}.gridDataTable.url`
            ) || catalogueTableConf.url;

        return dispatch(
            fetchData(
                catalogueStateKey,
                queryUrl(
                    url,
                    getCatalogueQueryParams(getState()[catalogueStateKey].refinement, page)
                )
            ))
            .then(({ pagination }) => Promise.all([
                dispatch(pagerActions.pagerUpdate(
                    catalogueStateKey,
                    pagination,
                    cataloguePagerLength
                )),
                dispatch(updateCatalogueLotsFound(pagination.totalItems))
            ]));
    };
}

export function updateCatalogueTableIfNeeded(page) {
    return (dispatch, getState) => (
        shouldUpdateTable(getState()) ?
            updateCatalogueTable(page)(dispatch, getState) :
            dispatch(tableActions.importData(catalogueStateKey))
    );
}

export function applyCatalogueRefinement(payload) {
    return (dispatch) => {
        dispatch(changeCatalogueRefinement(payload));
    };
}

export function applyDefaultCatalogueRefinement() {
    return (dispatch) => {
        dispatch(resetCatalogueRefinement());
    };
}

function createApplyFilterAction(filterKey, valueGetter = identity) {
    return rawValue => applyCatalogueRefinement({
        [filterKey]: valueGetter(rawValue)
    });
}

function createLoadOptionsAction(filterKey) {
    return () => dispatch => dispatch(fetchFilterOptions(filterKey))
        .then(options => dispatch(updateCatalogueData({
            [getCatalogueFilterOptionsKey(filterKey)]: options
        })));
}

const horseNameKey = 'horseName';
export const applyCatalogueHorseNameFilter = createApplyFilterAction(horseNameKey);
export const loadHorseNameOptions = createLoadOptionsAction(horseNameKey);

const horseSexKey = 'horseSex';
export const applyCatalogueHorseSexFilter = createApplyFilterAction(horseSexKey);
export const loadHorseSexOptions = createLoadOptionsAction(horseSexKey);

const horseAgeKey = 'horseAge';
export const applyCatalogueHorseAgeFilter = createApplyFilterAction(horseAgeKey);
export const loadHorseAgeOptions = createLoadOptionsAction(horseAgeKey);

const sireNameKey = 'sireName';
export const applyCatalogueSireNameFilter = createApplyFilterAction(sireNameKey);
export const loadSireNameOptions = createLoadOptionsAction(sireNameKey);

const damNameKey = 'damName';
export const applyCatalogueDamNameFilter = createApplyFilterAction(damNameKey);
export const loadDamNameOptions = createLoadOptionsAction(damNameKey);

const sireOfDamNameKey = 'sireOfDamName';
export const applyCatalogueSireOfDamNameFilter = createApplyFilterAction(sireOfDamNameKey);
export const loadSireOfDamNameOptions = createLoadOptionsAction(sireOfDamNameKey);

const sellerNameKey = 'sellerName';
export const applyCatalogueSellerNameFilter = createApplyFilterAction(sellerNameKey);
export const loadSellerNameOptions = createLoadOptionsAction(sellerNameKey);

const buyerDetailKey = 'buyerDetail';
export const applyCatalogueBuyerDetailFilter = createApplyFilterAction(buyerDetailKey);
export const loadBuyerDetailOptions = createLoadOptionsAction(buyerDetailKey);

const lotNoKey = 'lotNo';
export const applyCatalogueLotNoFilter = createApplyFilterAction(lotNoKey);

const enteredKey = 'entered';
export const applyCatalogueEnteredFilter = createApplyFilterAction(enteredKey);

const priceKey = 'price';
export const applyCataloguePriceFilter = createApplyFilterAction(priceKey);

const priceMinKey = 'minPrice';
export const applySearchPriceMinFilter = createApplyFilterAction(priceMinKey);

const priceMaxKey = 'maxPrice';
export const applySearchPriceMaxFilter = createApplyFilterAction(priceMaxKey);

export function openShortlistFailureLightbox() {
    return {
        type: CATALOGUE_SHORTLIST_FAILURE_LIGHTBOX_OPEN,
    };
}

export function closeShortlistFailureLightbox() {
    return {
        type: CATALOGUE_SHORTLIST_FAILURE_LIGHTBOX_CLOSE,
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/catalogue.js